module.exports = __webpack_public_path__ + "fonts/NotoSans-Italic.79ab268.woff";